import { render, staticRenderFns } from "./ModalContentAddManagerCommunity.vue?vue&type=template&id=25ecd37e&"
import script from "./ModalContentAddManagerCommunity.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddManagerCommunity.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddManagerCommunity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports